import {
  type ISocialLinks,
  socialIcons,
  Socials,
} from '@features/social-share';

export function SocialLinks({ links }: { links: ISocialLinks }) {
  const socials = Object.entries(links);

  return (
    <div className="flex flex-wrap justify-center gap-5 self-center lg:justify-end">
      {socials.map(([socialName, value]) => {
        const { url } = value;
        const key = value.order;
        const Icon = socialIcons[socialName as Socials];

        if (!url || !Icon) return null;

        return (
          <a
            style={{ textIndent: '-10000px' }}
            className="text-[0px]"
            href={url}
            target="_blank"
            key={key}
            rel="noreferrer"
          >
            {socialName}
            <Icon
              className="fill-(--footer-icon) lg:h-9 lg:w-9"
              width={40}
              height={40}
            />
          </a>
        );
      })}
    </div>
  );
}
